<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header
    fxLayout="row"
    class="mat-expansion-panel-header-overlay"
  >
    <mat-panel-title fxLayoutAlign="start center"
      >Establecimientos
    </mat-panel-title>

    <mat-panel-description fxLayoutAlign="end center">
      <button
        mat-icon-button
        [disabled]="isDisabledComponent"
        (click)="editEstablishment(-1, -1)"
        fxLayoutAlign="end center"
        color="accent"
      >
        <mat-icon>add</mat-icon>
      </button>
      <mat-icon>expand_more</mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <!--NIVEL 1-->

  <div>
    <cdk-accordion class="accordion" multi="true">
      <cdk-accordion-item
        *ngFor="let establish of establishments; let estIndex = index"
        #aiEstablishment="cdkAccordionItem"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="aiEstablishment.expanded"
      >
        <div
          class="accordion-item-header"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <mat-icon
            [@rotateArrow]="aiEstablishment.expanded ? 'expanded' : 'collapsed'"
            (click)="aiEstablishment.toggle()"
          >
            keyboard_arrow_right
          </mat-icon>
          <button
            mat-icon-button
            color="accent"
            (click)="
              editBranchOffice(-1, -1, establish.id, establish.number, estIndex)
            "
          >
            <mat-icon>add</mat-icon>
          </button>

          <div
            (click)="
              editEstablishment(establish.id, estIndex);
              aiEstablishment.toggle()
            "
            class="text-efect"
          >
            {{ establish.tradeName }}
          </div>
        </div>

        <!-- NIVEL 2 -->

        <div
          class="accordion-item-body"
          role="region"
          [@expandCollapse]="
            aiEstablishment.expanded ? 'expanded' : 'collapsed'
          "
        >
          <cdk-accordion-item
            *ngFor="
              let branch of establish.branchesOffice;
              let brnIndex = index
            "
            #aiBranch="cdkAccordionItem"
            role="button"
            tabindex="0"
            [attr.aria-expanded]="aiBranch.expanded"
          >
            <div
              class="accordion-item-header"
              fxLayout="row"
              fxLayoutAlign="start center"
            >
              <mat-icon
                [@rotateArrow]="aiBranch.expanded ? 'expanded' : 'collapsed'"
                (click)="aiBranch.toggle()"
              >
                keyboard_arrow_right
              </mat-icon>
              <mat-slide-toggle
                [checked]="branch.active"
                (change)="switchBranch(estIndex, brnIndex, $event)"
                fxLayoutAlign="center"
                fxFlex="5"
              >
              </mat-slide-toggle>
              <button
                mat-icon-button
                color="accent"
                (click)="editBussinesUnit(0, -1, branch.id, brnIndex, estIndex)"
              >
                <mat-icon>add</mat-icon>
              </button>

              <div fxLayoutAlign="start" fxFlex="70">
                <span
                  class="text-efect"
                  (click)="
                    editBranchOffice(
                      branch.id,
                      brnIndex,
                      establish.id,
                      establish.number,
                      estIndex
                    )
                  "
                >
                  {{ addZero(branch.number) }} SUC. {{ branch.citadel }}
                </span>
              </div>
              <div fxFlex="15" fxLayoutAlign="end">
                {{ branch.active ? 'Activo' : 'Inactivo' }}
              </div>
            </div>

            <!-- NIVEL 3 -->

            <div
              class="accordion-item-body body-business"
              role="region"
              [@expandCollapse]="aiBranch.expanded ? 'expanded' : 'collapsed'"
            >
              <cdk-accordion-item
                *ngFor="
                  let business of branch.businessUnit;
                  let bssIndex = index
                "
                #aiBusiness="cdkAccordionItem"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="aiBusiness.expanded"
              >
                <div
                  class="accordion-item-header"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                >
                  <mat-checkbox
                    class="example-margin"
                    fxLayoutAlign="center"
                    fxFlex="5"
                    [checked]="business?.active"
                    (change)="
                      switchBusiness(
                        estIndex,
                        brnIndex,
                        bssIndex,
                        business?.id!,
                        $event.checked
                      )
                    "
                  >
                  </mat-checkbox>
                  <button
                    mat-icon-button
                    color="accent"
                    (click)="
                      editBussinesUnit(
                        0,
                        bssIndex,
                        branch.id,
                        brnIndex,
                        estIndex
                      )
                    "
                  >
                    <mat-icon>add</mat-icon>
                  </button>

                  <div fxLayoutAlign="start" fxFlex="70">
                    <span
                      class="text-efect"
                      (click)="
                        editBussinesUnit(
                          business!.id!,
                          bssIndex,
                          branch.id,
                          brnIndex,
                          estIndex
                        )
                      "
                      class="text-efect"
                    >
                      {{ addZero(business?.number) }} U. NEG.
                      {{ business?.businessDirection?.canton?.name }} -
                      {{ business?.businessDirection?.storeName }}
                    </span>
                  </div>
                  <div fxFlex="15" fxLayoutAlign="end">
                    {{ business!.active ? 'Activo' : 'Inactivo' }}
                  </div>
                </div>
              </cdk-accordion-item>
            </div>
          </cdk-accordion-item>
        </div>
      </cdk-accordion-item>
    </cdk-accordion>
  </div>
</mat-expansion-panel>
